import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=33c85a7e&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"
import style0 from "./Process.vue?vue&type=style&index=0&id=33c85a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c85a7e",
  null
  
)

export default component.exports